import {Component, OnInit, OnDestroy,} from "@angular/core";
import * as Communication from "../communication/index";
import {ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import { Subscription } from 'rxjs';

@Component({
    selector: 'sd-fromDrive',
    templateUrl: 'fromDrive.component.html',
    styleUrls: ['fromDrive.component.css'],
    providers: [Communication.JobsService],
    standalone: false
})
export class FromDriveComponent implements OnInit {

  ids:any;
  action:string;
  userId:string;
  processState:string;
  theJob:Communication.Job;
  documentName:string;
  docsize:number;
  accessToken:string;
  userApikey:string;

  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];

  cloudFile:any = {
    "xhr":null,
    "fileName": "",
    "fileSize": "",
    "progress" : 0,
    "status": ""
  };

  isLoggedIn:boolean = true;
  missingParameters:boolean = false;
  corsError:boolean = false;

  constructor(private jobsApi:Communication.JobsService,
              private route: ActivatedRoute,
  )
  {

  }

  ngOnInit() {

    let parameters = this.route.snapshot.fragment
    console.log(parameters);

    let result1 = parameters.split("&");

    console.log(result1);

    let code;
    let state;
    let id_token;

    let tempResultArray;

    for(let i=0; i<result1.length;i++){
      console.log(result1[i].split("="));
      tempResultArray = result1[i].split("=");
      if(tempResultArray[0] == "code"){
        code = tempResultArray[1];
      } else if (tempResultArray[0] == "id_token"){
        id_token = tempResultArray[1];
      } else if(tempResultArray[0] == "state"){
        state = tempResultArray[1];
      }
    }

    console.log(state);
    console.log(code);
    console.log(id_token);

    let fullLink = Config.GOOGLE_APP_SCRIPT_URL + "?code="+code+"&state="+state+"&id_token="+id_token;

    window.location.replace(fullLink);

    return;

  }

}
